import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.83333 8.09831C1.83333 4.41683 4.81851 1.43164 8.5 1.43164C12.1815 1.43164 15.1667 4.41683 15.1667 8.09831C15.1667 11.7798 12.1815 14.765 8.5 14.765C6.97407 14.765 5.56666 14.2465 4.44074 13.3872L5.49259 12.3205C6.34444 12.9205 7.38148 13.2835 8.5 13.2835C11.3667 13.2835 13.6852 10.965 13.6852 8.09831C13.6852 5.23164 11.3667 2.91312 8.5 2.91312C5.63333 2.91312 3.31481 5.23164 3.31481 8.09831H1.83333Z"
      fill={color}
    />
  </svg>
);

Loading.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Loading;
